// extracted by mini-css-extract-plugin
var _1 = "zAlmg__wheelGrid";
var _2 = "zAlmg__wrapper";
export { _1 as "wheelGrid", _2 as "wrapper" }
